import { Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import { Button, FormGroup, Label } from "reactstrap";
import styles from "./Reset.module.scss";

const ResetPasswordForm = (props) => {
  const navigate = useNavigate();
  const { errors, touched } = props;

  return (
    <Form
      className={`${styles.resetForm} d-flex flex-column justify-content-center forgotPwd`}
    >
      <h3 className={styles.loginHeading}>Enter your registered email</h3>
      <FormGroup className="form-group">
        <Label>Email</Label>
        <Field
          name="email"
          className="form-control"
          // placeholder="Enter email"
          type="text"
        />
        {errors.email && touched.email ? (
          <div className={styles.formError}>{errors.email}</div>
        ) : null}
      </FormGroup>
      <p
        className={`ms-auto ${styles.resetPwd}`}
        onClick={() => navigate("/login")}
      >
        Back To Login
      </p>
      <Button
        type="submit"
        disabled={props?.submited}
        className={styles.brandButton}
      >
        {props?.submited && (
          <span className="spinner-border spinner-border-sm mr-1"></span>
        )}
        Send Email
      </Button>
    </Form>
  );
};

export default ResetPasswordForm;
